<template>
  <div class="invite_bgdwn">
    <div class="invite_code">{{ userid }}</div>
    <div class="btn" @click="$emit('click')">
      <img src="../assets/images/invitefriends/newInvite/Slicing/btn.png" alt>
    </div>
    <div class="invite_left">
      <span class="invite_num">{{ inviteNumber }}</span>
      <p class="text">邀请次数</p>
    </div>
    <div class="invite_right">
      <span class="invite_snum">{{ inviteSuccessNumber }}</span>
      <p class="text">邀请成功</p>
    </div>
    <Rules></Rules>
  </div>
</template>
<script>
import Rules from "../Component/Rules";
export default {
  name: "InviteInfo",
  data() {
    return {};
  },
  props: ['userid','inviteNumber','inviteSuccessNumber'],
  
  components: {
    Rules
  }
};
</script>
<style scoped>
.invite .invite_bgdwn {
  position: relative;
  height: 34.075rem;
  background: url("../assets/images/invitefriends/newInvite/Slicing/bgDw.png")
    no-repeat left bottom;
  background-size: cover;
}
.invite .invite_bgdwn .invite_code {
  position: absolute;
  top: 4.175rem;
  left: 6.25rem;
  width: 6.175rem;
  height: 0.85rem;
  font-family: "DINPro-Medium";
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.85rem;
  letter-spacing: 0rem;
  color: #ffffff;
}
.invite .invite_bgdwn .btn {
  position: absolute;
  bottom: 23.825rem;
  left: 5.05rem;
  width: 8.65rem;
  height: 3.2rem;
}
.invite .invite_bgdwn .btn img {
  width: 100%;
  height: 100%;
}
.invite .invite_bgdwn .invite_left {
  position: absolute;
  top: 17.875rem;
  left: 3.875rem;
  width: 3rem;
  height: 0.85rem;
  font-family: "DINPro-Medium";
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.85rem;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: center;
}
.invite .invite_bgdwn .text {
  font-size: 0.45rem;
  margin-top: 0.375rem;
}
.invite .invite_bgdwn .invite_right {
  position: absolute;
  top: 17.875rem;
  right: 3.875rem;
  width: 3rem;
  height: 0.85rem;
  font-family: "DINPro-Medium";
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.85rem;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/Component/InviteInfo.vue